type AccordionItem = {
  title?: string;
  body?: string;
};

export function AccordionBlock({ content }: { content: Record<string, unknown> }) {
  const heading = String(content.heading ?? "");
  const intro = String(content.intro ?? "");
  const items = (Array.isArray(content.items) ? content.items : []) as AccordionItem[];
  const visible = items.filter((item) => item.title || item.body);

  if (!heading && !intro && visible.length === 0) return null;

  return (
    <section className="mx-auto max-w-6xl px-4 py-[calc(var(--space-unit)*2.5)]">
      {(heading || intro) && (
        <div className="mb-[calc(var(--space-unit)*1.5)] max-w-3xl">
          {heading ? (
            <h2
              className="font-bold text-[var(--color-text)]"
              style={{ fontFamily: "var(--font-heading)", fontSize: "var(--text-h2)" }}
            >
              {heading}
            </h2>
          ) : null}
          {intro ? <p className="mt-2 text-[var(--color-secondary)]">{intro}</p> : null}
        </div>
      )}
      <div className="flex flex-col gap-3">
        {visible.map((item, index) => (
          <details
            key={`${item.title ?? "item"}-${index}`}
            className="rounded-[var(--border-radius)] border border-[var(--color-border)] bg-[var(--color-surface)] p-4"
          >
            <summary className="cursor-pointer text-lg font-medium text-[var(--color-text)]">
              {item.title || `Details ${index + 1}`}
            </summary>
            {item.body ? (
              <div
                className="prose mt-3 max-w-none text-[var(--color-secondary)]"
                dangerouslySetInnerHTML={{ __html: item.body }}
              />
            ) : null}
          </details>
        ))}
      </div>
    </section>
  );
}
